var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('popup', {
    attrs: {
      "opened": _vm.shown
    },
    on: {
      "close": _vm.close
    }
  }, [_vm.currentStage === 0 ? _c('div', [_c('div', {
    staticClass: "my-5 mx-20 lg:my-15 lg:mx-40 2xl:my-20 2xl:mx-32"
  }, [_c('div', {
    staticClass: "flex flex-col justify-center items-center"
  }, [_c('h3', {
    staticClass: "mb-10"
  }, [_vm._v("\n          Sélectionnez une photo de profil\n        ")]), _vm._v(" "), _c('h3', [_vm._v("OU")]), _vm._v(" "), _c('action-button', {
    attrs: {
      "bg-color": "bg-pink-600",
      "bg-color-hover": "bg-white",
      "bg-color-square": "bg-white",
      "bg-color-square-hover": "bg-pink-600",
      "border-color": "border-pink-600",
      "disabled": false,
      "icon": "arrow-right_1",
      "icon-color": "text-white",
      "libelle": "Choisir une autre image",
      "text-color": "text-white"
    },
    on: {
      "clickAction": function ($event) {
        return _vm.toStage(1);
      }
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _vm.currentStage === 1 ? _c('div', {
    on: {
      "drop": function ($event) {
        $event.preventDefault();
        return _vm.tempUpload.apply(null, arguments);
      },
      "dragover": function ($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "my-5 mx-20 lg:my-15 lg:mx-40 2xl:my-20 2xl:mx-32"
  }, [_c('h3', {
    staticClass: "mb-10"
  }, [_vm._v("\n        Importer une image\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "bg-indigo-100 rounded-lg flex flex-col items-center space-y-3 py-24"
  }, [_c('icon', {
    staticClass: "text-pink-600 w-12 h-12",
    class: {
      'animate-pulse': _vm.loading
    },
    attrs: {
      "name": "file"
    }
  }), _vm._v(" "), !_vm.loading ? _c('div', {
    staticClass: "flex flex-col items-center space-y-3"
  }, [_c('h3', {
    staticClass: "text-indigo-600"
  }, [_vm._v("\n            Glissez & Déposez\n          ")]), _vm._v(" "), _c('input', {
    staticClass: "hidden",
    attrs: {
      "type": "file",
      "id": "upload-file",
      "accept": "image/jpeg, image/png"
    },
    on: {
      "change": _vm.tempUpload
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "text-gray-600 cursor-pointer text-lg",
    attrs: {
      "for": "upload-file"
    }
  }, [_vm._v("\n            ou "), _c('span', {
    staticClass: "underline"
  }, [_vm._v("importez")]), _vm._v(" votre\n            image\n          ")]), _vm._v(" "), _vm.tooManyFiles ? _c('div', {
    staticClass: "text-red-500 text-sm"
  }, [_vm._v("\n            Veuillez ne sélectionner qu'une seule image à la\n            fois\n          ")]) : _vm._e(), _vm._v(" "), _vm.formatNotSupported ? _c('div', {
    staticClass: "text-red-500 text-sm"
  }, [_vm._v("\n            Format de l'image non supporté\n          ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm.loading ? _c('div', [_c('h6', {
    staticClass: "text-gray-600 animate-pulse"
  }, [_vm._v("\n            Image en cours d'envoi...\n          ")])]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), _vm.currentStage === 3 ? _c('div', [_c('div', {
    staticClass: "my-5 mx-20 lg:my-15 lg:mx-40 2xl:my-20 2xl:mx-32"
  }, [_c('div', {
    staticClass: "flex flex-col justify-center items-center"
  }, [_vm.self ? _c('h5', {
    staticClass: "mb-5"
  }, [_vm._v("\n          Votre nouvelle image de profil:\n        ")]) : _vm.firstname ? _c('h5', {
    staticClass: "mb-5"
  }, [_vm._v("\n          La nouvelle image de profil " + _vm._s(_vm.firstname) + ":\n        ")]) : _vm._e(), _vm._v(" "), _c('img', {
    staticClass: "object-cover max-w-64 w-64 h-64 2xl:max-w-80 2xl:w-80 2xl:h-80 mb-5 rounded-full border border-indigo-300",
    attrs: {
      "src": _vm.fileTemp.path
    }
  }), _vm._v(" "), _c('action-button', {
    attrs: {
      "bg-color": "bg-pink-600",
      "bg-color-hover": "bg-white",
      "bg-color-square": "bg-white",
      "bg-color-square-hover": "bg-pink-600",
      "border-color": "border-pink-600",
      "disabled": false,
      "icon": "arrow-right_1",
      "icon-color": "text-white",
      "libelle": "Continuer",
      "text-color": "text-white"
    },
    on: {
      "clickAction": function ($event) {
        return _vm.confirm();
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-2sm mt-10 text-gray-500 font-extra-light text-center italic"
  }, [_vm._v("            Il vous sera possible de repositionner l'image à\n          l'intérieur du cadre dans une prochaine version. Merci\n          de votre patience!\n        ")])], 1)])]) : _vm._e(), _vm._v(" "), _vm.currentStage === 4 ? _c('div', [_c('div', {
    staticClass: "my-5 mx-20 lg:my-15 lg:mx-40 2xl:my-20 2xl:mx-32"
  }, [_c('div', {
    staticClass: "flex flex-col justify-center items-center"
  }, [_vm.self ? _c('h3', {
    staticClass: "text-indigo-600 mb-10"
  }, [_vm._v("\n          Votre photo de profil a bien été mise à jour !\n        ")]) : _c('h3', {
    staticClass: "text-indigo-600 mb-10"
  }, [_vm._v("\n          La photo de profil " + _vm._s(_vm.firstname) + " a bien été mise à\n          jour !\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "w-full flex justify-center"
  }, [_c('illustration', {
    staticClass: "w-full",
    attrs: {
      "name": "basket"
    }
  })], 1)])])]) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }